<template>
  <div class="-app-headshot">
    <section class="section">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column is-3">
            <figure class="image">
              <img src="@/assets/gif/01.gif" class="-image" />
            </figure>
          </div>
          <div class="column is-9">
            <p class="subtitle">
              Jake Offermann is an artist living in Brooklyn New York. He enjoys
              psychedelic brightness, gothic gloom, and many things in between.
            </p>
            <div class="block">
              <a href="https://www.instagram.com/offworldart/" target="_blank">
                <b-icon
                  icon="instagram"
                  type="is-grey"
                  size="is-medium"
                  class="has-margin-right-10"
                ></b-icon>
              </a>
              <a
                href="https://www.linkedin.com/in/jake-offermann"
                target="_blank"
              >
                <b-icon
                  icon="linkedin"
                  type="is-grey"
                  size="is-medium"
                  class="has-margin-right-10"
                ></b-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AppHeadshot",
  data() {
    return {
      // currentIndex: 0,
      // headshots: [
      //   require("@/assets/img/01.png"),
      //   require("@/assets/img/02.png"),
      //   require("@/assets/img/03.png"),
      //   require("@/assets/img/04.png")
      // ]
    };
  },
  // methods: {
  //   advance() {
  //     if (this.currentIndex < this.headshots.length - 1) {
  //       this.currentIndex += 1;
  //     } else {
  //       this.currentIndex = 0;
  //     }
  //   },
  //   cycleThroughPhotos() {
  //     setInterval(this.advance, 125);
  //   }
  // },
  // mounted() {
  //   this.cycleThroughPhotos();
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
